module.exports = __webpack_public_path__ + "img/5.108f05e2.png";